<template>
  <div>
    <b-container>
      <div class="mt-4 d-lg-flex justify-content-between">
        <div class="statCard red">
          <span class="colorWriteWhite">{{ $t("Billable") }}</span>
          <span class="statNumber">{{ statistics.billable }}</span>
        </div>
        <div class="statCard orange mt-2 mt-lg-0">
          <span class="colorWriteWhite">{{ $t("QuoteToBeMade") }}</span>
          <span class="statNumber">{{ statistics.quoteToBeMade }}</span>
        </div>
        <div class="statCard green mt-2 mt-lg-0">
          <span class="colorWriteWhite">{{ $t("RetakeIntervention") }}</span>
          <span class="statNumber">{{ statistics.retakeIntervention }}</span>
        </div>
      </div>

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Intervention') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn">
          <plus-icon size="18" class="mr-1"/>
          {{ $t('Add') }} {{ $t('intervention') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableIntervention"
          identifier="B122TableIntervention"
          init-b122-table-url="/intervention/initB122Table"
          get-b122-table-results-url="/intervention/getB122TableResults"
          :fields="tableFields"
          initial-sort-by="estimatedStartDate"
          :initial-sort-desc="true"
          color-date-picker="pink"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        >
          <template #cell(statuses)="data">
            <div style="display: flex; flex-direction: row">
              <div v-for="(status, index) in data.value" :key="index">
                <p style="margin-top: 60%;" class="mr-2" :class=status.name></p>
              </div>
            </div>
          </template>

          <template #cell(endDate)="data">
            <div class="text-center">
              <check-icon v-if="data.item.endDate > 0" ></check-icon>
            </div>
          </template>

          <template #cell(addressIntervention.address)="data">
            <div>
              <a @click=goToAddressIntervention(data.item.addressIntervention.id) class="force-link" href="javascript:void(0)">{{data.item.addressIntervention.address}}</a>
            </div>
            <div>
              <a @click=goToAddressIntervention(data.item.addressIntervention.id) class="force-link" href="javascript:void(0)">{{data.item.addressIntervention.postalCode + " " + data.item.addressIntervention.city}}</a>
            </div>
          </template>

          <template #cell(technician.user.name)="data">
            <div>
              <a @click=goToTechnician(data.item.technician.id) class="force-link" href="javascript:void(0)">{{data.item.technician.name}}</a>
            </div>
          </template>

          <template #cell(client)="data">
            <div>
              <a @click=goToClient(data.item) class="force-link" href="javascript:void(0)">
                {{data.item.addressIntervention.tenant !== null ? (data.item.addressIntervention.tenant.name) :
                (data.item.addressIntervention.owner !== null ? (data.item.addressIntervention.owner.name) :
                  (data.item.addressIntervention.agency != null ? data.item.addressIntervention.agency.agencyName : ""))}}</a>
            </div>
          </template>


        </b122-table>
      </b-card>
    </b-container>
    <Intervention-delete-modal :selectedIntervention="ui.selectedIntervention" @didDeleteIntervention="didDeleteIntervention()"></Intervention-delete-modal>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import InterventionDeleteModal from "./InterventionDeleteModal";
import api from '../../services/api';
import i18n from '../../i18n'
import {dateUtils} from "@/mixins/utils";

export default {

  name: 'InterventionIndex',

  components: {
    B122Table,
    InterventionDeleteModal
  },

  data() {
    return {
      totalCount: 0,
      statistics: {
        billable: 0,
        quoteToBeMade: 0,
        retakeIntervention: 0,
      },
      tableFields: [
        {
          label: "",
          key: "show",
          sortable: false
        },
        {
          label: this.$i18n.t('DateIntervention'),
          key: "estimatedStartDate",
          sortable: true,
          sortKey: "estimatedStartDate",
          formatter: function (value, key, item) {
            return dateUtils.methods.formatDateSimple(value);
          }
        },
        {
          label: this.$i18n.t('Finished'),
          key: "endDate",
          sortable: true,
          formatter: function (value, key, item) {
            return dateUtils.methods.formatDateSimple(value);
          }
        },
        {
          label: this.$i18n.t('Technician'),
          key: "technician.user.name",
          sortable: true,
          sortKey: "technician.user.lastName"
        },
        {
          label: this.$i18n.t('Address'),
          key: "addressIntervention.address",
          sortable: true,
          sortKey: "addressIntervention.address",
        },
        {
          label: this.$i18n.t('Client'),
          key: "client",
          sortable: false,
        },
        {
          label: this.$i18n.t('intervention.Type'),
          key: "type.fr",
          sortable: true,
          formatter: function (value) {
            return i18n.t(value);
          },
        },
        {
          label: this.$i18n.t('intervention.Status'),
          key: "statuses"
        },
        {
          label: "",
          key: "actions"
        }
      ],
      ui: {
        selectedIntervention: null
      }
    }
  },

  mounted() {
    this.fetchStats();
  },

  methods: {

    fetchStats() {
      api.get(`/intervention/getStatsForIndex`)
        .then(response => {
          this.statistics.billable = response.data.billable[0]
          this.statistics.quoteToBeMade = response.data.quoteToBeMade[0]
          this.statistics.retakeIntervention = response.data.retakeIntervention[0]
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'InterventionCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'InterventionShow',
        params: {
          interventionId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'InterventionEdit',
        params: {
          interventionId: row.item.id
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.ui.selectedIntervention = row.item
      this.$bvModal.show('intervention-delete-modal')
    },

    didDeleteIntervention() {
      this.ui.selectedIntervention = null;
      this.$refs.B122TableIntervention.refreshTable()
    },

    goToClient(intervention) {
      var clientId = intervention.addressIntervention.tenant !== null ? (intervention.addressIntervention.tenant.id) :
        (intervention.addressIntervention.owner !== null ? (intervention.addressIntervention.owner.id) :
          (intervention.addressIntervention.agency != null ? intervention.addressIntervention.agency.id : null))

      this.$router.push({
        name: 'ClientShow',
        params: {
          clientId: clientId
        }
      })
    },

    goToTechnician(id) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          technicianId: id
        }
      })
    },

    goToAddressIntervention(id) {
      this.$router.push({
        name: 'AddressInterventionShow',
        params: {
          addressInterventionId: id
        }
      })
    },
  }
}
</script>


<style scoped>
.statCard {
  width: 30%;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--main-white);
  font-size: var(--title-level-one-font-size);
  font-weight: bold;
  word-break: break-word;
  flex-direction: column;
  border-radius: var(--main-border-radius);
}

@media (max-width: 992px) {
  .statCard {
    width: 100%;
  }
}

.statNumber {
  align-self: flex-start;
  font-size: 36px;
}

.colorWrite {
  align-self: flex-start;
  margin-bottom: auto;
  color: rgba(0, 0, 0, 0.50);
}

.colorWriteWhite {
  align-self: flex-start;
  margin-bottom: auto;
  color: rgba(255, 255, 255, 0.85);
}

.pink {
  background-color: var(--secondary-color);
}

.red {
  background-color: #FA0207;
}
.orange {
  background-color: #FFA200;
}
.green {
  background-color: #2CC646;
}

.Billable{
  width: 15px;
  height: 15px;
  border-radius: 10px;
  background: #FA0207;
  /*border:2px solid white;*/
}

.QuoteToBeMade{
  width: 15px;
  height: 15px;
  border-radius: 10px;
  border-color: white;
  background: #FFA200;
}

.RetakeIntervention{
  width: 15px;
  height: 15px;
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
  background: #2BC545;
}
</style>



// WEBPACK FOOTER //
// src/views/intervention/InterventionIndex.vue